import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinButton } from '../../components/ClinButton/ClinButton'
import { mediaQuery } from '../../utils/mediaQuery'

const tabletUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledCastorCard = styled.aside({
  position: 'relative',
  width: 'auto',
  borderRadius: ClinTheme.radii[3],
  background: ClinTheme.colors.white,
  border: `1px solid ${ClinTheme.colors.midGrey}`,
  overflow: 'hidden',
  [mediaQuery(tabletUpBreakpoint)]: {
    width: '266px'
  }
})

export const StyledCastorCardImage = styled.div`
  position: relative;
  width: 100%;
  height: 120px;
  background-image: url('/images/rwd-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const StyledCastorCardContent = styled.div`
  padding: ${ClinTheme.space[4]}px ${ClinTheme.space[3]}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${ClinTheme.space[3]}px;
`

export const StyledCastorCardButton = styled(ClinButton)({
  width: '100%',
  textTransform: 'initial',
  fontSize: '14px',
  lineHeight: `${ClinTheme.space[3]}px`,
  height: '48px'
})
